import { useState } from "#app";
const useUserAuthOry = () => {
  const userAuthOryData = useState("userAuthOry", () => {
  });
  const setUserAuthOryData = (userData) => {
    userAuthOryData.value = userData;
  };
  return {
    userAuthOryData,
    setUserAuthOryData
  };
};
export default useUserAuthOry;
